<div class="transport-registration-options">
  <sc-flex vertical fitHeight stretchContent>
    <app-transport-options-panel [model]="model" [showInternalTransportOptions]="false" mode="terminal"
    [showDriverHints]="true"></app-transport-options-panel>
    <sc-content-spacer vertical [double]="true"></sc-content-spacer>
    <sc-flex-fitting-content vertical>
      <sc-scroll-pane>
        <sc-items-grid [width]="400" [gap]="16">
          @for (resource of resources; track resource) {
            <ac-resource-image-view [resourceId]="resource"></ac-resource-image-view>
          }
        </sc-items-grid>
      </sc-scroll-pane>
    </sc-flex-fitting-content>
  </sc-flex>

</div>
